<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            @click="handleBack"
            class="me-2"
            variant="secondary"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
          />
        </div>
      </div>
    </div>
    <div class="clearfix mb-4">
      <h4 class="card-title float-start">
        {{ $t('maintenance.frontPage.title.infoGroupService') }}
      </h4>
      <div class="float-end d-flex">
        <McButton
          variant="secondary"
          @click="handleCancel"
          class="me-2"
          icon="icon-fill_close"
          :text="$t('global.cancel')"
          :disabled="!hasChanged"
        />
        <McButton
          variant="primary"
          type="button"
          @click="handleSubmit"
          icon="icon-outline_save"
          :text="$t('global.save')"
          :disabled="!hasChanged"
        />
      </div>
    </div>

    <b-skeleton-wrapper :loading="!detailData.ssgroupName">
      <template #loading>
        <b-card>
          <b-row class="my-3">
            <b-col>
              <b-skeleton width="100%" height="30px" />
            </b-col>
            <b-col>
              <b-skeleton width="50%" height="30px" />
            </b-col>
            <b-col>
              <b-skeleton width="50%" height="30px" />
            </b-col>
          </b-row>
        </b-card>
      </template>

      <b-card>
        <b-row class="mc-list-info__top">
          <b-col>
            <FormulateForm :errors="error">
              <FormulateInput
                name="service"
                v-model="detailData.ssgroupName"
                :value="detailData.ssgroupName"
                required
                type="text"
                :placeholder="`${$t('global.form.enter')} ${$t(
                  'maintenance.field.groupServiceName'
                )}`"
                validation-behavior="live"
                error-behavior="live"
                @input="saveName"
              >
                <template #label>
                  <div class="d-flex justify-content-between align-items-center">
                    <label
                      >{{ $t('maintenance.field.groupServiceName') }}
                      <i class="text-danger">*</i></label
                    >
                  </div>
                </template>
              </FormulateInput>
            </FormulateForm>
          </b-col>

          <b-col v-if="render">
            <span>{{ $t('maintenance.field.totalScheduleService') }}</span>
            <strong>{{ detailData.services.length }}</strong>
          </b-col>

          <b-col v-if="render">
            <span>{{ $t('maintenance.field.totalUseFleet') }}</span>
            <strong>{{ detailData.vehicles.length }}</strong>
          </b-col>
        </b-row>
      </b-card>
    </b-skeleton-wrapper>

    <b-card class="mc-card__setting" v-if="render">
      <ScheduleService
        :isDuplicate="isDuplicate"
        :hasVehicle="detailData.vehicles.length > 0"
        @refreshData="refreshData"
      />
    </b-card>
    <b-card class="mc-card__setting" v-if="render">
      <Fleet
        :disabled="detailData.services.length > 0 && !isDuplicate ? false : true"
        :servicesId="servicesId"
        :isDuplicate="isDuplicate"
        :hasTemplate="hasTemplate"
        @refreshData="refreshData"
      />
    </b-card>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import McButton from '@/components/McButton'
import Layout from '@/router/layouts/main'
import ScheduleService from './serviceschedules/ScheduleService'
import Fleet from './vehicle/FleetSsgroup'
import {
  GET_SERVICE_SCHEDULE_GROUP_BY_ID,
  GET_SERVICE_SCHEDULE_GROUP,
  UPDATE_SERVICE_SCHEDULE_GROUP,
} from '@/services/api/maintenance/serviceSchedules'
import { DUPLICATE_SSGROUP } from '@/services/api/maintenance/ssgroup'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ScheduleService,
    Fleet,
    McButton,
  },

  apollo: {
    ssgroup: {
      query: GET_SERVICE_SCHEDULE_GROUP_BY_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ssgroupId: Number(this.$route.params.ssgroupId),
          },
        }
      },
      result({ data, loading }) {
        if (loading) {
          return
        }
        this.ssgroupById = data.ssgroup.ssgroup

        const services = data.ssgroup.ssgroup.service2Ssgroup.map((item) => {
          return {
            serviceId: item.serviceId,
            companyId: item.service.companyId,
            intervalDistance: item.intervalDistance,
            reminderDistance: item.reminderDistance,
            intervalTime: item.intervalTime,
            reminderTime: item.reminderTime,
            intervalHourmeter: item.intervalHourmeter,
            reminderHourmeter: item.reminderHourmeter,
            intervalPeriod: this.checkValue(item.intervalPeriod),
            reminderPeriod: this.checkValue(item.reminderPeriod),
            startServiceAtDistance: item.startServiceAtDistance,
            startServiceAtTime: item.startServiceAtTime,
          }
        })

        let vehicles = []
        vehicles = data.ssgroup.ssgroup.vehicles.map((item) => {
          return item.id
        })

        this.oldData = {
          ssgroupName: data.ssgroup.ssgroup.name,
          services: services,
          vehicles: vehicles,
        }

        if (this.isDuplicate) vehicles = []

        this.detailData = {
          ssgroupName: this.ssgroupById.name,
          services: services,
          vehicles: vehicles,
        }

        if (this.$store.state.maintenance.serviceGroupName) {
          this.detailData.ssgroupName = this.$store.state.maintenance.serviceGroupName
        }

        this.nameValidation(this.detailData.ssgroupName)
        this.hasTemplate = services.some((item) => item.companyId == 1)
      },
    },
  },

  data() {
    return {
      ssgroups: [],
      ssgroupById: {},
      detailData: {
        ssgroupName: '',
        services: [],
        vehicles: [],
      },
      oldData: {},
      licensePlateSelect: [],
      compServiceSelect: [],
      intPeriodeSelect: [],
      reminderPeriodeSelect: [],
      licensePlateOptions: ['L 1234 LL', 'W 1234 WW', 'P 1234 PP'],
      compServiceOptions: [],
      intPeriodeOptions: ['Hari', 'Minggu', 'Bulan'],
      reminderPeriodeOptions: ['Hari', 'Minggu', 'Bulan'],
      showHideDetail: false,
      showNotifInfo: false,
      render: true,
      isDuplicate: false,
      error: {},
      hasDelete: false,
      hasTemplate: false,
    }
  },

  computed: {
    title() {
      return this.$t('maintenance.detailGroup.title')
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceGroup'),
          to: { name: 'Service Group' },
        },
        {
          text: this.$t('maintenance.detailGroup.title'),
        },
      ]
    },

    servicesId() {
      return this.ssgroup?.ssgroup.service2Ssgroup.map((x) => x.serviceId)
    },

    hasChanged() {
      const res = this.filterUnchangedData(this.detailData, this.oldData)
      return res[1]
    },
  },

  created() {
    if (this.$route.params.duplicate) {
      this.isDuplicate = true
      this.error = {
        service: 'Nama grup penjadwalan tidak boleh duplikat',
      }
    }
  },

  beforeDestroy() {
    if (
      this.$route.name == 'Add Component Schedule' ||
      this.$route.name == 'Detail Component Schedule' ||
      this.$route.name == 'Scheduled Conflict' ||
      this.$route.name == 'Detail Service Schedule'
    )
      return
    this.clearState()
  },

  methods: {
    saveName(value) {
      this.nameValidation(value)

      this.$store.commit('maintenance/SET_GROUP_NAME', value)
    },

    async nameValidation(value) {
      if (this.isDuplicate) {
        const res = await this.$apollo.query({
          query: GET_SERVICE_SCHEDULE_GROUP,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              pagination: {
                show: 99999,
                page: 1,
              },
            },
          },
        })
        this.ssgroups = res.data.ssgroups.ssgroups.data
        const groupNames = res.data.ssgroups.ssgroups.data.map((item) => {
          return item.name
        })

        setTimeout(() => {
          const duplicated = groupNames.includes(value)
          if (duplicated) {
            this.error = {
              service: 'Nama grup penjadwalan tidak boleh duplikat',
            }
            return false
          } else this.error = {}
        }, 800)
      }
    },

    async handleSubmit() {
      if (!this.isDuplicate) {
        const input = {
          ssgroupId: Number(this.$route.params.ssgroupId),
          oldData: { name: this.oldData.ssgroupName },
          newData: { name: this.detailData.ssgroupName },
        }

        const res = await this.$apollo.mutate({
          mutation: UPDATE_SERVICE_SCHEDULE_GROUP,
          variables: {
            input: input,
          },
        })

        if (res.data.updateSsgroup.isSuccessful) {
          this.$mcToast.success(this.$t('global.alert.text.added'))
          this.$router.push({
            name: 'Detail Group Service',
            params: { ssgroupId: this.$route.params.ssgroupId },
          })
        } else this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      } else {
        let name = this.detailData.ssgroupName

        const res = await this.$apollo.mutate({
          mutation: DUPLICATE_SSGROUP,
          variables: {
            input: {
              name: name,
              ssgroupId: Number(this.$route.params.ssgroupId),
            },
          },
        })

        if (res.data.duplicateSsgroup.isSuccessful) {
          this.$mcToast.success(this.$t('global.alert.text.added'))
          this.render = false
          this.$router.push({
            name: 'Detail Group Service',
            params: { ssgroupId: res.data.duplicateSsgroup.duplicateSsgroup.ssgroupId },
          })
          this.isDuplicate = false

          setTimeout(() => {
            this.render = true
          }, 500)
        } else this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
      }
      this.clearState()
    },

    handleBack() {
      this.$router.push({ name: 'Service Group' })
      this.clearState()
    },

    clearState() {
      this.$store.commit('maintenance/RESET_VEHICLES_SERVICES')
      this.$store.commit('maintenance/RESET_FIX_VEHICLES')
    },

    checkValue(data) {
      switch (data) {
        case 'd':
          return 'day'
        case 'w':
          return 'week'
        case 'm':
          return 'month'

        default:
          return data
      }
    },

    handleCancel() {
      this.detailData.ssgroupName = this.oldData.ssgroupName
    },

    refreshData() {
      this.render = false
      this.$apollo.queries.ssgroup.refetch()

      setTimeout(() => {
        this.render = true
      }, 500)
    },

    filterUnchangedData(newValue, oldValue) {
      const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)])
      const _newValue = {}
      keys.forEach((key) => {
        if (key == 'services' || key == 'vehicles') return
        if (oldValue[key] == newValue[key]) return
        _newValue[key] = newValue[key]
      })

      const entries = Object.entries(_newValue)
      const hasChanged = entries.length > 0 && entries.every((value) => value)
      return [_newValue, hasChanged]
    },
  },
}
</script>

<style lang="scss" scoped>
ul.formulate-input-errors {
  list-style: none;
  margin: 0px !important;
  padding: 0px 0px 0px 0px !important;
  color: $red;
  font-size: $font-size-sm;
  font-style: italic;

  li.formulate-input-error::before {
    content: '' !important;
    color: $red;
    font-weight: 600;
    display: inline-block;
  }
}
</style>
